import { useTextBlockStyles } from './TextBlock.styles';
import { jsx as _jsx } from "react/jsx-runtime";
const TextBlock = ({
  text,
  size,
  weight,
  color,
  align
}) => {
  const style = useTextBlockStyles({
    size,
    weight,
    color,
    align
  });
  return /*#__PURE__*/_jsx("p", {
    style: style,
    children: text
  });
};
export default TextBlock;